import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, AutoComplete } from 'components/Ui';
import usRegions from 'utils/regionsData/usRegions.json';

import styles from './styles.scss';
import commonStyles from '../styles.scss';

const regionsOptions = usRegions.map((region) => ({
  value: region.abbreviation,
  label: region.abbreviation,
}));

const DeliveryInformationForm = ({ values, onClose }) => {
  const [changed, handleChange] = useState(false);
  const onChange = () => handleChange(true);

  return (
    <Form className={commonStyles.form}>
      <div className={commonStyles.formContainer}>
        <div className={commonStyles.header}>My delivery address</div>
        <div className={commonStyles.inputBlock}>
          <Input
            label="*First Name"
            name="firstName"
            ariaLabel="First Name"
            smallLabel
            defaultValue={values.firstName}
            onChange={onChange}
          />
          <Input
            label="*Last Name"
            name="lastName"
            ariaLabel="Last Name"
            smallLabel
            defaultValue={values.lastName}
            onChange={onChange}
          />
        </div>
        <Input
          label="Company"
          ariaLabel="Company Name"
          smallLabel
          defaultValue={values.company}
          onChange={onChange}
        />
        <div className={commonStyles.inputBlock}>
          <Input
            label="*Street Address"
            name="streetAddress"
            ariaLabel="Street address"
            smallLabel
            defaultValue={values.streetAddress}
            onChange={onChange}
          />
          <Input
            label="Apt/Ste/Other"
            name="apt"
            ariaLabel="Apartment suite other"
            smallLabel
            defaultValue={values.apt}
            onChange={onChange}
          />
        </div>
        <div className={commonStyles.inputBlock}>
          <Input
            label="*City"
            name="city"
            ariaLabel="City"
            smallLabel
            defaultValue={values.city}
            onChange={onChange}
          />
          <div className={styles.selectBlock}>
            <AutoComplete
              darkDropdown
              label="*State"
              name="state"
              ariaLabel="State"
              smallLabel
              defaultValue={values.state}
              onChange={onChange}
              options={regionsOptions}
              className={styles.stateSelect}
              isClearable={false}
            />
            <Input
              label="*Zip"
              name="zip"
              ariaLabel="ZIP code"
              smallLabel
              defaultValue={values.zip}
              onChange={onChange}
            />
          </div>
        </div>
      </div>
      <div className={commonStyles.bottom}>
        <Button
          className={commonStyles.cancelButton}
          text="Cancel"
          onClick={onClose}
        />
        <Button
          className={commonStyles.button}
          text="Save"
          disabled={!changed}
        />
      </div>
    </Form>
  );
};

DeliveryInformationForm.propTypes = {
  values: PropTypes.object,
  onClose: PropTypes.func,
};

export default DeliveryInformationForm;
